
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/showings",
      function () {
        return require("private-next-pages/showings/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/showings"])
      });
    }
  